import React from 'react';

class Body extends React.Component {
  render() {
    const currentlocation = window.location.href;
    const showdashboard = currentlocation.includes('/powerbi');
    return (
      <div className={showdashboard && showdashboard?"powerbiport":"viewport"}>
        <main id="content">{this.props.children}</main>
      </div>
    );
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/ui/layout/Body/index.js